var React = require('react');

function ShowMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.119 9.00003L2.28697 16.832H1.16797V15.713L7.88097 9.00003L1.16797 2.28703V1.16803H2.28697L10.119 9.00003Z","fill":"#2CD0DB","stroke":"#179DC6","strokeWidth":"0.5","strokeLinejoin":"round"}));
}

ShowMore.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = ShowMore;

ShowMore.default = ShowMore;
